export default {
    univ: '45526c3c-cde2-11eb-b9f5-ee71e529c769',
    social: '4c7bb7f7-cde2-11eb-b9f5-ee71e529c769',
    premium: '509132d2-cde2-11eb-b9f5-ee71e529c769',
    fans: '3da8623e-cde2-11eb-b9f5-ee71e529c769',
    momentum: '491c7245-cde2-11eb-b9f5-ee71e529c769',
    selfemployeed: '419817dd-cde2-11eb-b9f5-ee71e529c769',
};
